if (!customElements.get('heritage-hero')) {
  customElements.define(
    'heritage-hero',
    class HeritageHero extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.index = 0;
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.dots = [...this.querySelectorAll('[data-hero-dot]')];
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(-1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.heroDot)));
        });
        this.timer = setInterval(() => this.go(1), 7000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      go(step) {
        this.show((this.index + step + this.slides.length) % this.slides.length);
      }

      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.hidden = i !== index;
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }
  );
}
